module.exports = __webpack_public_path__ + "media/components/greenroom-articles/static/placeholder-5734046fb6737db712cef1f4e7cd1ca1.png";